import { css } from 'styled-components';

export const getTheme = (props, component) => {
  if (!props.theme) return null;
  if (!props.theme[component]) return null;
  return css(...props.theme[component]);
};
